import styled from 'styled-components';
import { FontFamilyRegular } from '../fonts';

export const WarningMessageContainer = styled.div`
    width: 100%;
    border-radius: 20px;
    border: solid 2px ${props => props.isSuccess ? '#3da4ac' : '#f7bf28'};
    background-color: #ffffff;
    position: relative;
    padding: 12px 20px 10px 20px;
`;

export const WarningMessageText = styled.p`
    ${FontFamilyRegular};
    font-size: 13px;
    margin: 0;
    padding: 0;
    font-weight: 500;
`;

export const WarningMessageIconContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    transform: translateX(-50%) translateY(-50%);
`;

export const WarningMessageSubmitContainer = styled.div`
    width: auto;
    max-width: 90%;
    margin: 0px auto 40px auto;

    ${props => props.theme.mediaQueries.tablet} {
        max-width: 100%;
        margin: 0px 0px 40px 0px;
    };
`;